import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { useContext } from '../Context'
import { Specification } from './Specification'
import {
  BigLoadingPlaceholder,
  FullTableLoadingPlaceholder,
  LoadingPlaceholder,
  MediumLoadingPlaceholder,
  ShowIf,
  SmallLoadingPlaceholder,
} from '@ztechapps/webui.util'
import { RichTextDisplay } from '@ztechapps/webui.input'
import { AssetImages } from './AssetImages'
import { Stack } from 'react-bootstrap'

const DescriptionLoadingPlaceholder = () => (
  <Stack gap={2}>
    <BigLoadingPlaceholder />
    <MediumLoadingPlaceholder />
    <SmallLoadingPlaceholder />
    <FullTableLoadingPlaceholder />
    <MediumLoadingPlaceholder />

    <BigLoadingPlaceholder />
  </Stack>
)

export const FullDescription = () => {
  const { document, loading } = useContext()
  return (
    <div className="col-md-8">
      <LoadingPlaceholder loading={loading} as={DescriptionLoadingPlaceholder}>
        <ShowIf condition={!isEmpty(document?.fullDescription)}>
          <div className="fw-bold mb-3 ">Description</div>
          {/* trustedSource: product description is staff-authored in the admin app, not attacker-reachable */}
          <RichTextDisplay contentHtml={document?.fullDescription} trustedSource />
        </ShowIf>
        <Specification />
        <AssetImages />
      </LoadingPlaceholder>
    </div>
  )
}
